import React, {
  Fragment,
  useCallback,
  useState,
  useEffect,
  useRef,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { query } from '../Actions/FacetedSearch.action';
import SortCriteriaCompact from './SortCriteriaCompact';
import { updateFilterOption } from '../Actions/FacetedSearch.action';
import { PRODUCT_VIEW_CACHED } from '../constants';
import FilterTogglerButton from './FilterTogglerButton';

const FacetedSearchCompactContainer = () => {
  const dispatch = useDispatch();
  const {
    subNavigation,
    sortCriteria,
    facetFilters: globalFacetFilters,
    navigationTheme,
    productsViewCachedId,
  } = useSelector((state) => state.facetedSearch);

  const [facetFilters, setFacetFilters] = useState(globalFacetFilters || []);
  const previousCachedId = useRef(productsViewCachedId);
  useEffect(() => {
    if (previousCachedId.current !== productsViewCachedId) {
      setFacetFilters(globalFacetFilters);
      previousCachedId.current = productsViewCachedId;
    }
  }, [globalFacetFilters, productsViewCachedId]);

  useEffect(() => {
    dispatch(query(window.location.search.substr(1) || '', false, false));
  }, [dispatch]);

  const onFacetChange = useCallback(
    (filter, option) => {
      setFacetFilters((prevFacetFilters) => {
        return updateFilterOption(prevFacetFilters, filter, option);
      });
    },
    [setFacetFilters]
  );

  const empty = (array) => !(array && array.length);

  const subNavigations = !subNavigation ? null : [subNavigation];
  const sortCriterias =
    !sortCriteria || !sortCriteria.sortItems ? null : sortCriteria.sortItems;

  const hidden = [subNavigations, facetFilters, sortCriterias].every((arr) =>
    empty(arr)
  );
  return hidden ? null : (
    <div className="mobile-filter-header">
      <FilterTogglerButton />
      {sortCriteria && (
        <SortCriteriaCompact {...{ sortCriteria: sortCriterias }} />
      )}
    </div>
  );
};

export default FacetedSearchCompactContainer;
